module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10222.09cfbad3.jpg";